import React from 'react'
import { useCreateCampaignStepsContext } from '../campaign-create-steps-context'
import { AgentType, CUSTOM_AGENT, INTERVIEW_AGENT, SALES_AGENT } from '../../../agent-type'
import { InterviewDetailsStep } from './interview-details-step'
import { PromptDetailsStep } from './prompt-details-step'

const detailsStepComponent: Record<AgentType, React.ComponentType> = {
    [INTERVIEW_AGENT]: InterviewDetailsStep,
    [CUSTOM_AGENT]: PromptDetailsStep,
    [SALES_AGENT]: PromptDetailsStep,
}

export function DetailsStep() {
    const { selectedType, noAvailableTypes } = useCreateCampaignStepsContext()

    if (noAvailableTypes || !selectedType) {
        return null
    }

    const Component = detailsStepComponent[selectedType]

    return <Component />
}
